import React, { useEffect, useState } from "react";
import { Flex, Dialog, CloseIcon, Button, Alert, ProviderConsumer} from "@fluentui/react-northstar";
import { LifecyclePowerAutomateTask } from "../utils/typings";
import { PhasePowerAutomateTaskForm } from "./PhasePowerAutomateTaskForm";
import { BUTTONS, LIFECYCLE } from '../../shared/utils/constants';


interface Props {
  open: boolean;
  onCancel: () => void;
  saveTask: (data: LifecyclePowerAutomateTask) => void;
  initData: LifecyclePowerAutomateTask;
  userList: PlatformUser[];
}

export const PhasePowerAutomateTaskDialog = ({ open, onCancel, saveTask, initData, userList }: Props) => {

  const [taskData, setTaskData] = useState<LifecyclePowerAutomateTask>(initData);
  const validateRequired = () => {
    setAlert({ title: '', show: false, attributes: {} });
    if (taskData.Name  === '') {
      setAlert({
        title: LIFECYCLE.REQUIRED_FIELD_MESSAGE,
        show: true,
        attributes: { danger: true }
      });
      return true;
    }
    return false;
  };

  const [alert, setAlert] = useState({
    title: '',
    show: false,
    attributes: {}
  });

  const primaryClick = async () => {
    if (validateRequired()) return;
    saveData();
    onCancel();
  }

  const closeDialog = () => {
    setAlert({ title: '', show: false, attributes: {} });
    onCancel();
    setTaskData(initData);
  }

  useEffect(() => {
    if (open) {
      setAlert({ title: '', show: false, attributes: {} });
      setTaskData(initData);
    }
  }, [open]);
  
  const renderPages = () => {
    return <PhasePowerAutomateTaskForm
      taskData={taskData}
      setTaskData={setTaskData}
      userList={userList}
    />
  }

  const saveData = () => {
    saveTask(taskData);
    setTaskData(initData);
  }

  return (
    <Dialog className="relate-ticket-dialog"
      content={renderPages()}
      open={open}
      headerAction={{
        icon: <CloseIcon />,
        title: LIFECYCLE.CLOSE,
        onClick: closeDialog
      }}
      header={{
        content: (
          <div className="w-full">
            <h3 className="mt-0">{(taskData.Guid.length > 0) ? BUTTONS.EDIT : LIFECYCLE.ADD} {LIFECYCLE.POWER_AUTOMATE_TASK}</h3>
            {alert.show && (
              <Alert fitted {...alert.attributes} content={alert.title} className="w-full text-xs"/>
            )}
          </div>
        ),        
      }}
      footer={
        <ProviderConsumer 
          render={(_globalTheme) => (
            <Flex gap="gap.small">
              <>
                <Flex.Item push><Button content={BUTTONS.CANCEL} onClick={closeDialog} /></Flex.Item>
                <Button className="dialog-btn" content={(taskData.Guid.length > 0) ? BUTTONS.SAVE : LIFECYCLE.ADD} primary onClick={primaryClick}/>
              </>
            </Flex>
          )}
        />
      }
    />
  )
};